// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.io-container {
  font-family: "Roboto";
  display: flex;
  flex-direction: column;
}

.io-header {
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 100%;
}

.io-sub-header {
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  color: #5b5e5d;
  margin-top: 8px;
}
.io-content-div {
  height: 700px;
  overflow-y: scroll;
}

.io-tabs {
  border-radius: 10px;
  padding-left: 13px;
  position: sticky;
  top: 0;
  margin-bottom: 0;
}
.confirm-campaign-text {
  position: relative;
  display: inline-block;
  left: 2rem;
}
.io-tabs .ant-tabs-nav {
  background: #e9e9e9;
  font-family: "Roboto";
  border-radius: 5px;
  position: sticky;
  top: 0;
}
.io-tabs .ant-tabs-tab-active {
  height: 64px;
  opacity: 1;
  top: 13px;
  left: 13px;
  gap: 8px;
  border-radius: 8px;
  padding-top: 10px;
  padding-right: 18px;
  padding-bottom: 10px;
  padding-left: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.io-tabs .ant-tabs-tab {
  width: 100%;
  justify-content: center;
}
.io-tabs .ant-tabs-tab-btn {
  color: #000 !important;
  margin-left: 10px;
}

.io-tabs .ant-tabs-ink-bar {
  display: none !important;
}
.io-tabs .ant-tabs-nav::before {
  border: 0;
}

.io-tabs .tab-header-id,
.io-container .client-name {
  color: #8e9190;
  font-weight: 400;
  font-size: 13px;
}
.io-container .client-name {
  margin-top: 5px;
}
.io-tabs .tab-header-name {
  font-weight: 500;
  font-size: 18px;
  padding-bottom: 0.4rem;
}

.io-tabs .io-overview {
  font-size: 16px;
  font-weight: 400;
}

.io-tabs .io-unsigned {
  font-size: 13px;
  font-weight: 400;
  display: flex;
  justify-content: center;
}

.io-download-btn {
  padding: 14px 20px;
  height: 52px;
  background: #f0f0f0 !important;
  color: #000 !important;
  font-weight: 500;
  font-size: 16px;
  border: none;
}
.overview-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 29px;
}

.io-overview-card .campaign-label {
  font-weight: 400;
  color: #8e9190;
  font-size: 13px;
}

.io-overview-card .campaign-value {
  font-weight: 500;
  font-size: 19px;
}

.io-overview-card {
  background-color: #fff;
}

.io-container .ant-tabs-content-holder {
  background: #f9f9f9 !important;
}

/* Tab content container - scrollable */
.tab-content-scrollable {
  flex: 1 1;
  /* overflow-y: auto;
  overflow-x: hidden; */
  padding: 16px 0;
}

.io-container .tab-content-container {
  margin-left: 12px;
  display: flex;
  flex-direction: column;
}

.io-container .launch-campaign-text {
  font-size: 16px;
  background: #fff;
  border-radius: 10px;
  font-family: "Roboto";
}

.io-container .launch-header {
  font-weight: 600;
  height: 24px;
  margin-bottom: 6px;
}
.io-container .launch-sub-header {
  font-weight: 400;
  color: #5b5e5d;
  line-height: 24px;
  margin-bottom: 1rem;
}

.io-container .campaign-io-preview {
  margin-top: 25px;
}

.io-container .campaign-io-preview::-webkit-scrollbar {
  display: flex;
  width: 7px !important;
  height: 7px;
}

.io-container .campaign-io-preview::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Sticky side content */
.sticky-side-content {
  position: sticky;
  top: 0px; /* Adjust based on header height */
  max-height: calc(100vh - 140px);
  overflow-y: auto;
}

.io-container .product-headers {
  font-size: 16px;
  font-weight: 600;
  font-family: "Roboto";
}
.chat-space {
  color: #5b5e5d;
}
.io-container .product-title {
  font-size: 16px;
  font-weight: 400;
}

/* Docusign section styling */
.docu-sign-section {
  margin-top: auto;
  position: sticky;
  display: flex;
  /* z-index: 2;
  justify-content: center; */
}

.docu-sign-option-container {
  width: 100%;
}
.sign-card {
  padding-bottom: 0;
}

.io-footer {
  background: white;
  padding: 24px;
  border-top: 1px solid #f0f0f0;
  margin-bottom: 2rem;
  position: relative;
}

.main-content-inner {
  /* height: 400px; */
  /* overflow-y: auto; */
}

.main-content-inner::-webkit-scrollbar {
  width: 10px !important;
  display: block !important;
  visibility: visible !important;
}

.main-content-inner::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 5px !important;
}

.main-content-inner::-webkit-scrollbar-thumb {
  background: #c1c1c1 !important;
  border-radius: 5px !important;
  border: 2px solid #f1f1f1 !important;
}

.main-content-inner::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

.main-content-inner::-webkit-scrollbar-corner {
  background: #f1f1f1 !important;
}

.main-content-inner {
  /* overflow-y: scroll !important; */
}

.main-content-inner::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2) !important;
}
.chat-icon {
  cursor: pointer;
  width: 24px !important;
  height: auto !important;
}
.sticky-side-content .zero-padding-div {
  margin: 12px !important;
}
.sign-info-text {
  background: rgb(250, 225, 230);
  color: rgb(210, 4, 45);
  margin-top: 1rem;
  display: inline-block;
  padding: 0.5rem;
  border-radius: 10px;
}

.error-message {
  background: rgb(250, 225, 230);
  color: rgb(210, 4, 45);
  margin-top: 1rem;
  display: block; /* Change from inline-block to block */
  padding: 0.5rem;
  border-radius: 10px;
  text-align: center;
  width: 100%; /* Ensure full width */
}
.docusign-buttons {
  display: flex;
  gap: 4rem;
  justify-content: end;
}
.forward-btn {
  background: none !important;
  border: 1px solid #d9d9d9 !important;
  color: #000 !important;
  margin-right: 0.5rem;
  border-radius: 14px;
}
.truncates {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  display: inline-block;
}
.docusign-refresh-section {
  display: flex;
  flex-direction: column;
}
.io-mail-success-text {
  /* display: flex; */
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.io-mail-success-text .ant-card-body {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.docusign-submitted-response {
  display: flex;
  align-items: center;
}

.docu-sign-mail-action-btns {
  display: flex;
}
.docu-sign-mail-action-btns .resend-btn {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.docu-signer {
  color: #3944bc;
}
.re-designed-order-summary {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
}
.re-designed-container {
  width: 72% !important;
  max-height: 78vh !important;
  overflow-y: auto !important;
}
.order-summary-re-designed-div {
  width: 27% !important;
  max-height: 78vh !important;
  overflow-y: auto !important;
}
.main-content-area {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}
.redesigned-io-container {
  display: flex;
  gap: 10px;
}
@media ((max-width: 1440px)) {
  .main-content-area {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
  .re-designed-order-summary {
    display: flex;
    flex-direction: column;
  }
}

@media ((max-width: 1300px)) {
  .io-header {
    font-size: 18px;
  }
  .io-sub-header,
  .tab-header-name {
    font-size: 15px !important;
  }
  .io-tabs .ant-tabs-tab {
    width: 280px;
  }
  .io-tabs .tab-header-id,
  .io-container .client-name {
    font-size: 11px;
  }
  .io-overview-card .campaign-value {
    font-size: 14px;
  }
  .overview-content {
    margin-bottom: 14px;
  }
  .io-download-btn {
    padding: 14px 12px;
    height: 30px;
  }
}
/* Mobile responsive styles */
@media (max-width: 768px) {
  .main-content-area {
    width: 100% !important;
    flex-direction: column !important;
  }
  .re-designed-container {
    width: 100% !important;
    max-height: auto !important;
    overflow-y: auto !important;
  }
  .order-summary-re-designed-div {
    width: 100% !important;
  }
  .io-container {
    width: 100%;
    margin-left: 8%;
    height: auto;
    display: block;
  }

  .sticky-header-section {
    padding: 0 16px;
    position: relative;
  }

  .main-content-area {
    padding: 0 16px;
    overflow: visible;
  }

  .io-container .launch-header {
    height: auto;
  }
  .confirm-docusign {
    right: inherit;
    display: inline-flex;
    border: none;
  }
  .tab-content-scrollable {
    overflow: visible;
    padding: 8px 0;
  }

  .sticky-side-content {
    position: relative;
    top: 0;
    max-height: none;
  }

  .docu-sign-section {
    position: relative;
  }
  .docusign-submitted-response {
    display: block;
  }
  .docu-sign-mail-action-btns {
    margin-top: 0.5rem;
  }
  .docu-sign-mail-action-btns .resend-btn {
    margin-left: 0;
  }
  .icon-align {
    display: block !important;
    justify-self: center;
  }
  .io-download-btn {
    padding: 12px;
  }
  .io-doc {
    font-size: 14px;
  }
  .io-header {
    font-size: 16px;
    font-weight: 600;
  }
  .io-sub-header {
    line-height: 18.2px;
    font-size: 13px;
  }
  .io-tabs {
    padding-left: 0;
    position: sticky;
    top: 0;
  }
  .io-tabs .ant-tabs-nav {
    position: sticky;
    top: 0;
  }
  .io-tabs .ant-tabs-tab {
    width: 197px;
    padding: 10px 18px;
    gap: 8px;
  }
  .io-tabs .tab-header-name {
    font-size: 16px;
  }
  .io-tabs .ant-tabs-tab-active {
    height: 60px !important;
    align-items: center !important;
    display: flex !important;
  }
  .confirm-help-text {
    margin-left: 12px;
    margin-top: 24px;
  }
  .products-list {
    margin-left: 12px;
    padding: 0 12px 0 0;
  }
  .io-overview-card .campaign-value {
    font-size: 16px;
  }
  .mobile-confirm-card {
    margin-top: 22px;
  }
  .docusign-buttons {
    flex-direction: column;
    gap: 1rem;
  }
  .continue-btn {
    right: inherit;
  }
  .refresh-btn {
    color: #000000e0 !important;
    border-radius: #d9d9d9;
  }
}

.reservation-banner {
  width: 100%;
  background: #fffbeb;
  border: 1px solid #fed7aa;
  border-radius: 16px;
  padding: 16px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  font-family: "Roboto";
}

.reservation-lock {
  width: 44px;
  height: 44px;
  background: #fef3c7;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.reservation-lock .anticon {
  color: #d97706;
  font-size: 18px;
}

.reservation-info {
  flex: 1 1;
  min-width: 0;
}

.reservation-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #92400e;
  font-size: 14px;
  font-weight: 500;
  font-family: "Roboto";
}

.reservation-subtitle {
  margin-top: 4px;
  color: #5b5e5d;
  font-size: 14px;
  font-weight: 400;
  font-family: "Roboto";
  line-height: 1.5714285714285714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reservation-timer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.reservation-timer {
  width: 150px;
  height: 60px;
  background: #d97706 !important;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
}

.reservation-timer-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reservation-timer-content .anticon {
  color: #ffffff;
  font-size: 18px;
}

.reservation-timer .ant-statistic {
  margin-bottom: 0;
}

.reservation-timer .ant-statistic-content {
  color: #ffffff !important;
  font-size: 22px !important;
  font-weight: 700;
  line-height: 1;
}

.reservation-timer-label {
  margin-top: 6px;
  color: #8e9190;
  font-size: 16px;
  font-weight: 500;
  font-family: "Roboto";
}

.reservation-status {
  display: flex;
  flex-direction: column;
  min-width: 220px;
  flex-shrink: 0;
}

.reservation-status-item {
  display: flex;
  align-items: center;
  gap: 1px;
  color: #5b5e5d;
  font-size: 14px;
  font-weight: 400;
  font-family: "Roboto";
}
.card-body-style.ant-card .ant-card-body {
  padding: 0px !important;
}
.forward-close-btn {
  width: 20px !important;
  height: 20px !important;
  min-width: 32px !important;
  padding: 0 !important;

  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  background: transparent !important;
  background-color: transparent !important;

  border: none !important;
  box-shadow: none !important;

  color: #98a2b3 !important;

  cursor: pointer !important;
}
.forward-camp-input.ant-input-outlined {
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}
/* Remove AntD hover/active background */
.forward-close-btn:hover,
.forward-close-btn:focus,
.forward-close-btn:active {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;

  color: #667085 !important;
}

/* The actual CloseOutlined icon */
.forward-close-btn .anticon {
  width: 20px !important;
  height: 20px !important;

  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  font-size: 20px !important;
  line-height: 1 !important;

  color: #98a2b3 !important;
}

/* Hover only changes the X color */
.forward-close-btn:hover .anticon {
  color: #667085 !important;
}
.reservation-status-item .anticon {
  color: #22c55e;
  font-size: 16px;
}

@media (max-width: 768px) {
  .reservation-banner {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
  .reservation-info {
    width: 100%;
  }
  .reservation-subtitle {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
  .reservation-timer-wrapper {
    align-self: center;
  }
  .reservation-status {
    width: 100%;
  }
}

.reservation-timer .ant-statistic-content {
  letter-spacing: 3px;
}

.reservation-banner-warning {
  background: #fff1f2;
  border: 1px solid #fca5a5;
}

.reservation-timer-warning {
  background: #e11d48;
}

@keyframes timerBlink {
  0% {
    background-color: #e11d48;
  }
  50% {
    background-color: #fb7185;
  }
  100% {
    background-color: #e11d48;
  }
}

.reservation-timer-warning {
  animation: timerBlink 1s infinite;
}
.reservation-lock-warning {
  background: #ffe4e6;
}
.reservation-lock-warning .anticon {
  color: #e11d48;
}
.reservation-title-warning {
  color: #e11d48;
}
.warning-icon {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.reservation-expired-banner {
  width: 100%;
  /* min-height: 125px; */
  background: #fff1f2;
  border: 1px solid #fca5a5;
  border-radius: 16px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
}

.reservation-expired-icon {
  width: 44px;
  height: 44px;
  background: #ffe4e6;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.reservation-expired-icon .anticon {
  color: #e11d48;
  font-size: 18px;
}

.reservation-expired-content {
  flex: 1 1;
}

.reservation-expired-title {
  color: #dc2626;
  font-size: 24px;
  font-weight: 500;
}

.reservation-expired-text {
  color: #dc2626;
  font-size: 14px;
  line-height: 22px;
}

@media (max-width: 768px) {
  .reservation-expired-banner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px 16px;
    gap: 12px;
  }
  .reservation-expired-content {
    width: 100%;
  }
  .reservation-expired-title {
    font-size: 20px;
    line-height: 28px;
  }
  .reservation-expired-text {
    font-size: 14px;
    line-height: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/io-signing/IOSigning.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP;uBACqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,QAAQ,EAAE,kCAAkC;EAC5C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb;4BAC0B;AAC5B;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAE,sCAAsC;EACtD,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW,EAAE,sBAAsB;AACrC;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;AACA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,MAAM;EACR;EACA;IACE,gBAAgB;IAChB,MAAM;EACR;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;;EAErB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;;EAElC,kCAAkC;EAClC,wCAAwC;;EAExC,uBAAuB;EACvB,2BAA2B;;EAE3B,yBAAyB;;EAEzB,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA,wCAAwC;AACxC;;;EAGE,kCAAkC;EAClC,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;;EAE3B,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,uBAAuB;;EAEvB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;;EAElC,0BAA0B;EAC1B,yBAAyB;;EAEzB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".io-container {\n  font-family: \"Roboto\";\n  display: flex;\n  flex-direction: column;\n}\n\n.io-header {\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 100%;\n}\n\n.io-sub-header {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  color: #5b5e5d;\n  margin-top: 8px;\n}\n.io-content-div {\n  height: 700px;\n  overflow-y: scroll;\n}\n\n.io-tabs {\n  border-radius: 10px;\n  padding-left: 13px;\n  position: sticky;\n  top: 0;\n  margin-bottom: 0;\n}\n.confirm-campaign-text {\n  position: relative;\n  display: inline-block;\n  left: 2rem;\n}\n.io-tabs .ant-tabs-nav {\n  background: #e9e9e9;\n  font-family: \"Roboto\";\n  border-radius: 5px;\n  position: sticky;\n  top: 0;\n}\n.io-tabs .ant-tabs-tab-active {\n  height: 64px;\n  opacity: 1;\n  top: 13px;\n  left: 13px;\n  gap: 8px;\n  border-radius: 8px;\n  padding-top: 10px;\n  padding-right: 18px;\n  padding-bottom: 10px;\n  padding-left: 18px;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 16px;\n}\n\n.io-tabs .ant-tabs-tab {\n  width: 100%;\n  justify-content: center;\n}\n.io-tabs .ant-tabs-tab-btn {\n  color: #000 !important;\n  margin-left: 10px;\n}\n\n.io-tabs .ant-tabs-ink-bar {\n  display: none !important;\n}\n.io-tabs .ant-tabs-nav::before {\n  border: 0;\n}\n\n.io-tabs .tab-header-id,\n.io-container .client-name {\n  color: #8e9190;\n  font-weight: 400;\n  font-size: 13px;\n}\n.io-container .client-name {\n  margin-top: 5px;\n}\n.io-tabs .tab-header-name {\n  font-weight: 500;\n  font-size: 18px;\n  padding-bottom: 0.4rem;\n}\n\n.io-tabs .io-overview {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.io-tabs .io-unsigned {\n  font-size: 13px;\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n}\n\n.io-download-btn {\n  padding: 14px 20px;\n  height: 52px;\n  background: #f0f0f0 !important;\n  color: #000 !important;\n  font-weight: 500;\n  font-size: 16px;\n  border: none;\n}\n.overview-content {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 29px;\n}\n\n.io-overview-card .campaign-label {\n  font-weight: 400;\n  color: #8e9190;\n  font-size: 13px;\n}\n\n.io-overview-card .campaign-value {\n  font-weight: 500;\n  font-size: 19px;\n}\n\n.io-overview-card {\n  background-color: #fff;\n}\n\n.io-container .ant-tabs-content-holder {\n  background: #f9f9f9 !important;\n}\n\n/* Tab content container - scrollable */\n.tab-content-scrollable {\n  flex: 1;\n  /* overflow-y: auto;\n  overflow-x: hidden; */\n  padding: 16px 0;\n}\n\n.io-container .tab-content-container {\n  margin-left: 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.io-container .launch-campaign-text {\n  font-size: 16px;\n  background: #fff;\n  border-radius: 10px;\n  font-family: \"Roboto\";\n}\n\n.io-container .launch-header {\n  font-weight: 600;\n  height: 24px;\n  margin-bottom: 6px;\n}\n.io-container .launch-sub-header {\n  font-weight: 400;\n  color: #5b5e5d;\n  line-height: 24px;\n  margin-bottom: 1rem;\n}\n\n.io-container .campaign-io-preview {\n  margin-top: 25px;\n}\n\n.io-container .campaign-io-preview::-webkit-scrollbar {\n  display: flex;\n  width: 7px !important;\n  height: 7px;\n}\n\n.io-container .campaign-io-preview::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Sticky side content */\n.sticky-side-content {\n  position: sticky;\n  top: 0px; /* Adjust based on header height */\n  max-height: calc(100vh - 140px);\n  overflow-y: auto;\n}\n\n.io-container .product-headers {\n  font-size: 16px;\n  font-weight: 600;\n  font-family: \"Roboto\";\n}\n.chat-space {\n  color: #5b5e5d;\n}\n.io-container .product-title {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n/* Docusign section styling */\n.docu-sign-section {\n  margin-top: auto;\n  position: sticky;\n  display: flex;\n  /* z-index: 2;\n  justify-content: center; */\n}\n\n.docu-sign-option-container {\n  width: 100%;\n}\n.sign-card {\n  padding-bottom: 0;\n}\n\n.io-footer {\n  background: white;\n  padding: 24px;\n  border-top: 1px solid #f0f0f0;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.main-content-inner {\n  /* height: 400px; */\n  /* overflow-y: auto; */\n}\n\n.main-content-inner::-webkit-scrollbar {\n  width: 10px !important;\n  display: block !important;\n  visibility: visible !important;\n}\n\n.main-content-inner::-webkit-scrollbar-track {\n  background: #f1f1f1 !important;\n  border-radius: 5px !important;\n}\n\n.main-content-inner::-webkit-scrollbar-thumb {\n  background: #c1c1c1 !important;\n  border-radius: 5px !important;\n  border: 2px solid #f1f1f1 !important;\n}\n\n.main-content-inner::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8 !important;\n}\n\n.main-content-inner::-webkit-scrollbar-corner {\n  background: #f1f1f1 !important;\n}\n\n.main-content-inner {\n  /* overflow-y: scroll !important; */\n}\n\n.main-content-inner::-webkit-scrollbar-thumb {\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2) !important;\n}\n.chat-icon {\n  cursor: pointer;\n  width: 24px !important;\n  height: auto !important;\n}\n.sticky-side-content .zero-padding-div {\n  margin: 12px !important;\n}\n.sign-info-text {\n  background: rgb(250, 225, 230);\n  color: rgb(210, 4, 45);\n  margin-top: 1rem;\n  display: inline-block;\n  padding: 0.5rem;\n  border-radius: 10px;\n}\n\n.error-message {\n  background: rgb(250, 225, 230);\n  color: rgb(210, 4, 45);\n  margin-top: 1rem;\n  display: block; /* Change from inline-block to block */\n  padding: 0.5rem;\n  border-radius: 10px;\n  text-align: center;\n  width: 100%; /* Ensure full width */\n}\n.docusign-buttons {\n  display: flex;\n  gap: 4rem;\n  justify-content: end;\n}\n.forward-btn {\n  background: none !important;\n  border: 1px solid #d9d9d9 !important;\n  color: #000 !important;\n  margin-right: 0.5rem;\n  border-radius: 14px;\n}\n.truncates {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 90%;\n  display: inline-block;\n}\n.docusign-refresh-section {\n  display: flex;\n  flex-direction: column;\n}\n.io-mail-success-text {\n  /* display: flex; */\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.io-mail-success-text .ant-card-body {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.docusign-submitted-response {\n  display: flex;\n  align-items: center;\n}\n\n.docu-sign-mail-action-btns {\n  display: flex;\n}\n.docu-sign-mail-action-btns .resend-btn {\n  margin-left: 0.4rem;\n  margin-right: 0.4rem;\n}\n.docu-signer {\n  color: #3944bc;\n}\n.re-designed-order-summary {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 10px;\n}\n.re-designed-container {\n  width: 72% !important;\n  max-height: 78vh !important;\n  overflow-y: auto !important;\n}\n.order-summary-re-designed-div {\n  width: 27% !important;\n  max-height: 78vh !important;\n  overflow-y: auto !important;\n}\n.main-content-area {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n}\n.redesigned-io-container {\n  display: flex;\n  gap: 10px;\n}\n@media ((max-width: 1440px)) {\n  .main-content-area {\n    width: 100% !important;\n    display: flex;\n    justify-content: space-between;\n    padding: 20px;\n  }\n  .re-designed-order-summary {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n@media ((max-width: 1300px)) {\n  .io-header {\n    font-size: 18px;\n  }\n  .io-sub-header,\n  .tab-header-name {\n    font-size: 15px !important;\n  }\n  .io-tabs .ant-tabs-tab {\n    width: 280px;\n  }\n  .io-tabs .tab-header-id,\n  .io-container .client-name {\n    font-size: 11px;\n  }\n  .io-overview-card .campaign-value {\n    font-size: 14px;\n  }\n  .overview-content {\n    margin-bottom: 14px;\n  }\n  .io-download-btn {\n    padding: 14px 12px;\n    height: 30px;\n  }\n}\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .main-content-area {\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n  .re-designed-container {\n    width: 100% !important;\n    max-height: auto !important;\n    overflow-y: auto !important;\n  }\n  .order-summary-re-designed-div {\n    width: 100% !important;\n  }\n  .io-container {\n    width: 100%;\n    margin-left: 8%;\n    height: auto;\n    display: block;\n  }\n\n  .sticky-header-section {\n    padding: 0 16px;\n    position: relative;\n  }\n\n  .main-content-area {\n    padding: 0 16px;\n    overflow: visible;\n  }\n\n  .io-container .launch-header {\n    height: auto;\n  }\n  .confirm-docusign {\n    right: inherit;\n    display: inline-flex;\n    border: none;\n  }\n  .tab-content-scrollable {\n    overflow: visible;\n    padding: 8px 0;\n  }\n\n  .sticky-side-content {\n    position: relative;\n    top: 0;\n    max-height: none;\n  }\n\n  .docu-sign-section {\n    position: relative;\n  }\n  .docusign-submitted-response {\n    display: block;\n  }\n  .docu-sign-mail-action-btns {\n    margin-top: 0.5rem;\n  }\n  .docu-sign-mail-action-btns .resend-btn {\n    margin-left: 0;\n  }\n  .icon-align {\n    display: block !important;\n    justify-self: center;\n  }\n  .io-download-btn {\n    padding: 12px;\n  }\n  .io-doc {\n    font-size: 14px;\n  }\n  .io-header {\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .io-sub-header {\n    line-height: 18.2px;\n    font-size: 13px;\n  }\n  .io-tabs {\n    padding-left: 0;\n    position: sticky;\n    top: 0;\n  }\n  .io-tabs .ant-tabs-nav {\n    position: sticky;\n    top: 0;\n  }\n  .io-tabs .ant-tabs-tab {\n    width: 197px;\n    padding: 10px 18px;\n    gap: 8px;\n  }\n  .io-tabs .tab-header-name {\n    font-size: 16px;\n  }\n  .io-tabs .ant-tabs-tab-active {\n    height: 60px !important;\n    align-items: center !important;\n    display: flex !important;\n  }\n  .confirm-help-text {\n    margin-left: 12px;\n    margin-top: 24px;\n  }\n  .products-list {\n    margin-left: 12px;\n    padding: 0 12px 0 0;\n  }\n  .io-overview-card .campaign-value {\n    font-size: 16px;\n  }\n  .mobile-confirm-card {\n    margin-top: 22px;\n  }\n  .docusign-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .continue-btn {\n    right: inherit;\n  }\n  .refresh-btn {\n    color: #000000e0 !important;\n    border-radius: #d9d9d9;\n  }\n}\n\n.reservation-banner {\n  width: 100%;\n  background: #fffbeb;\n  border: 1px solid #fed7aa;\n  border-radius: 16px;\n  padding: 16px 24px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-sizing: border-box;\n  font-family: \"Roboto\";\n}\n\n.reservation-lock {\n  width: 44px;\n  height: 44px;\n  background: #fef3c7;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.reservation-lock .anticon {\n  color: #d97706;\n  font-size: 18px;\n}\n\n.reservation-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.reservation-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #92400e;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Roboto\";\n}\n\n.reservation-subtitle {\n  margin-top: 4px;\n  color: #5b5e5d;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"Roboto\";\n  line-height: 1.5714285714285714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reservation-timer-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.reservation-timer {\n  width: 150px;\n  height: 60px;\n  background: #d97706 !important;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n}\n\n.reservation-timer-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.reservation-timer-content .anticon {\n  color: #ffffff;\n  font-size: 18px;\n}\n\n.reservation-timer .ant-statistic {\n  margin-bottom: 0;\n}\n\n.reservation-timer .ant-statistic-content {\n  color: #ffffff !important;\n  font-size: 22px !important;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.reservation-timer-label {\n  margin-top: 6px;\n  color: #8e9190;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Roboto\";\n}\n\n.reservation-status {\n  display: flex;\n  flex-direction: column;\n  min-width: 220px;\n  flex-shrink: 0;\n}\n\n.reservation-status-item {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  color: #5b5e5d;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"Roboto\";\n}\n.card-body-style.ant-card .ant-card-body {\n  padding: 0px !important;\n}\n.forward-close-btn {\n  width: 20px !important;\n  height: 20px !important;\n  min-width: 32px !important;\n  padding: 0 !important;\n\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n\n  background: transparent !important;\n  background-color: transparent !important;\n\n  border: none !important;\n  box-shadow: none !important;\n\n  color: #98a2b3 !important;\n\n  cursor: pointer !important;\n}\n.forward-camp-input.ant-input-outlined {\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n/* Remove AntD hover/active background */\n.forward-close-btn:hover,\n.forward-close-btn:focus,\n.forward-close-btn:active {\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n\n  color: #667085 !important;\n}\n\n/* The actual CloseOutlined icon */\n.forward-close-btn .anticon {\n  width: 20px !important;\n  height: 20px !important;\n\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n\n  font-size: 20px !important;\n  line-height: 1 !important;\n\n  color: #98a2b3 !important;\n}\n\n/* Hover only changes the X color */\n.forward-close-btn:hover .anticon {\n  color: #667085 !important;\n}\n.reservation-status-item .anticon {\n  color: #22c55e;\n  font-size: 16px;\n}\n\n@media (max-width: 768px) {\n  .reservation-banner {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n  }\n  .reservation-info {\n    width: 100%;\n  }\n  .reservation-subtitle {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n  .reservation-timer-wrapper {\n    align-self: center;\n  }\n  .reservation-status {\n    width: 100%;\n  }\n}\n\n.reservation-timer .ant-statistic-content {\n  letter-spacing: 3px;\n}\n\n.reservation-banner-warning {\n  background: #fff1f2;\n  border: 1px solid #fca5a5;\n}\n\n.reservation-timer-warning {\n  background: #e11d48;\n}\n\n@keyframes timerBlink {\n  0% {\n    background-color: #e11d48;\n  }\n  50% {\n    background-color: #fb7185;\n  }\n  100% {\n    background-color: #e11d48;\n  }\n}\n\n.reservation-timer-warning {\n  animation: timerBlink 1s infinite;\n}\n.reservation-lock-warning {\n  background: #ffe4e6;\n}\n.reservation-lock-warning .anticon {\n  color: #e11d48;\n}\n.reservation-title-warning {\n  color: #e11d48;\n}\n.warning-icon {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n}\n\n.reservation-expired-banner {\n  width: 100%;\n  /* min-height: 125px; */\n  background: #fff1f2;\n  border: 1px solid #fca5a5;\n  border-radius: 16px;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.reservation-expired-icon {\n  width: 44px;\n  height: 44px;\n  background: #ffe4e6;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.reservation-expired-icon .anticon {\n  color: #e11d48;\n  font-size: 18px;\n}\n\n.reservation-expired-content {\n  flex: 1;\n}\n\n.reservation-expired-title {\n  color: #dc2626;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.reservation-expired-text {\n  color: #dc2626;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n@media (max-width: 768px) {\n  .reservation-expired-banner {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 20px 16px;\n    gap: 12px;\n  }\n  .reservation-expired-content {\n    width: 100%;\n  }\n  .reservation-expired-title {\n    font-size: 20px;\n    line-height: 28px;\n  }\n  .reservation-expired-text {\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
